import { useState, useEffect } from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  const [animateClass, setAnimateClass] = useState("");
  
  useEffect(() => {
    if (isOpen) {
      setAnimateClass("md:animate-none animate-slideUp");
    } else if (animateClass.includes("animate-slideUp")) {
      setAnimateClass("md:animate-none animate-slideDown");
      setTimeout(() => setAnimateClass(""), 300);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  if (!isOpen && animateClass !== "animate-slideDown") return null;
  
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm">
      <div className={`bg-white dark:bg-black p-3 rounded-t-lg md:rounded-lg shadow-lg w-full max-w-xs mx-auto transition-transform duration-300 ${animateClass}`}>
        <p className="text-lg font-semibold mb-4 dark:text-white text-center text-black">{message}</p>
        <div className="flex justify-center items-center gap-2 mt-4">
          <button
            onClick={onClose}
            className="w-full py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md">
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="w-full px-4 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
